import Vue from 'vue';
import App from './App.vue';
import './classComponentHooks';
import router from './router';
import store from './store';

import VueMeta from 'vue-meta';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import Vuelidate from 'vuelidate';
import VueInfiniteLoading from 'vue-infinite-loading';
import Vue2TouchEvents from 'vue2-touch-events';
import AOS from 'aos';
import 'aos/dist/aos.css';
import VueGtag, { bootstrap } from 'vue-gtag';
import vClickOutside from 'v-click-outside';
import Toast from 'vue-toastification';

import AppConfig from '@/config';
import AppLoader from './components/partials/AppLoader.vue';
import { getCookiePolicySettings } from '@/helpers/privacyPolicyModal';

import { createApolloProvider } from './apollo-setup';

Vue.use(VueMeta);
Vue.use(VueInfiniteLoading, {
  props: {
    spinner: 'spiral',
  },
  slots: {
    error: '',
    noMore: '',
    noResults: '',
  },
});
Vue.use(Vue2TouchEvents, {
  disableClick: false,
  touchClass: '',
  tapTolerance: 10,
  swipeTolerance: 30,
  longTapTimeInterval: 400,
});
Vue.use(VueAwesomeSwiper);
Vue.use(Vuelidate);
Vue.use(require('vue-moment'));
Vue.use(vClickOutside);
Vue.use(Toast);
Vue.use(
  VueGtag,
  {
    appName: 'The Cultivist Members',
    bootstrap: false, // always false — we control bootstrap manually now
    config: {
      id: AppConfig.getAsString('googleAnalyticsId'),
    },
    pageTrackerScreenviewEnabled: true,
    pageTrackerUseFullPath: true,
  },
  router
);

const { settings } = getCookiePolicySettings();
const isGaEnabled = settings.performanceAnalytics || false;
Vue.prototype.$gtagReady = isGaEnabled ? bootstrap() : Promise.resolve(null);

Vue.component('AppLoader', AppLoader);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  apolloProvider: createApolloProvider(),
  mounted() {
    AOS.init({ offset: 70 });
  },
  render: (h) => h(App),
}).$mount('#app');
